<template>
  <vs-row >
    <vs-col class="d-flex" style="justify-content: space-between">
      <span>TRACKING: {{$store.state.id}}</span> <button @click="clearFiles">CLEAR FILES</button>
    </vs-col>
  </vs-row>
</template>

<script>
  import { EVENT_CLEAR_FILES, EventBus } from '../../utils/EventBus';

  export default {
    name: "DebugLandingRow",
    methods: {
      clearFiles() {
        EventBus.$emit(EVENT_CLEAR_FILES)
      }
    }
  }
</script>

<style scoped>

</style>
